export const SITE = {
  name: "A&F Insurance Group, Inc.",
  shortName: "A&F Insurance Group",
  phone1: "954-540-2539",
  phone1Href: "tel:+19545402539",
  phone2: "954-251-7022",
  phone2Href: "tel:+19542517022",
  email: "Armando@afinsurancegroup.com",
  emailDiana: "diana@afinsurancegroup.com",
  address1: "The Exchange Building",
  address2: "3333 West Commercial Blvd., Suite 203",
  address3: "Fort Lauderdale, Florida 33309",
};

export const NAV = [
  { path: "/", key: "home" },
  { path: "/about", key: "about" },
  { path: "/properties", key: "properties" },
  { path: "/business", key: "business" },
  { path: "/hurricane", key: "hurricane" },
  { path: "/companies", key: "companies" },
];

export const PROGRAM_META = [
  { id: "commercial-property", icon: "Building2" },
  { id: "condo-associations", icon: "Building" },
  { id: "hoa-associations", icon: "House" },
  { id: "hazard-wind", icon: "Wind" },
  { id: "liquor-liability", icon: "Wine" },
  { id: "cyber-liability", icon: "Laptop" },
  { id: "general-liability", icon: "ShieldCheck" },
  { id: "umbrella", icon: "Umbrella" },
  { id: "professional-liability", icon: "Briefcase" },
  { id: "directors-officers", icon: "Users" },
  { id: "crime", icon: "Fingerprint" },
  { id: "business-income", icon: "TrendingUp" },
  { id: "flood", icon: "Waves" },
  { id: "workers-comp", icon: "HardHat" },
  { id: "bop", icon: "Package" },
];

export const PERIL_META = [
  { icon: "Wind" },
  { icon: "Waves" },
  { icon: "Tornado" },
  { icon: "ArrowDownToDot" },
  { icon: "Zap" },
  { icon: "CloudHail" },
];

export const CARRIERS = [
  "Ace Westchester", "Allianz", "American Coastal", "AmRisc", "Arch", "Aspen Specialty",
  "AXIS", "Beazley", "Berkshire Hathaway / Gateway", "Chubb", "Colony", "Covington",
  "Everest", "General Star", "Great American", "The Hartford", "ICAT", "Lexington",
  "Lloyd's of London", "London / AIG", "Mt. Hawley", "Mt. Vernon", "Safeco", "Scottsdale",
  "Seneca", "Sigma", "Starr Companies", "Travelers", "United National", "Universal P&C",
];

export const CARRIER_LOGOS = [
  { name: "Allianz", file: "allianz.png", match: "Allianz" },
  { name: "Berkshire Hathaway", file: "berkshire-hathaway.png", match: "Berkshire Hathaway / Gateway" },
  { name: "CNA", file: "cna.png", match: null },
  { name: "Chubb", file: "chubb.png", match: "Chubb" },
  { name: "Liberty Mutual Insurance", file: "liberty-mutual.png", match: null },
  { name: "Lloyd's of London", file: "lloyds.png", match: "Lloyd's of London" },
  { name: "Markel", file: "markel.png", match: null },
  { name: "Scottsdale Insurance Company", file: "scottsdale.png", match: "Scottsdale" },
  { name: "The Hartford", file: "hartford.png", match: "The Hartford" },
  { name: "Travelers", file: "travelers.png", match: "Travelers" },
  { name: "Universal Property & Casualty", file: "universal-pc.png", match: "Universal P&C" },
  { name: "Arch Insurance", file: "arch.png", match: "Arch" },
  { name: "AXIS", file: "axis.jpg", match: "AXIS" },
  { name: "Beazley", file: "beazley.png", match: "Beazley" },
  { name: "Everest", file: "everest.png", match: "Everest" },
  { name: "ICAT", file: "icat.png", match: "ICAT" },
  { name: "Safeco", file: "safeco.png", match: "Safeco" },
  { name: "Starr Companies", file: "starr.png", match: "Starr Companies" },
  { name: "AIG", file: "aig.png", match: "London / AIG" },
  { name: "Ace Westchester", file: "ace-westchester.png", match: "Ace Westchester" },
  { name: "American Coastal", file: "american-coastal.png", match: "American Coastal" },
  { name: "AmRisc Group", file: "amrisc.png", match: "AmRisc" },
  { name: "Aspen Specialty", file: "aspen-specialty.png", match: "Aspen Specialty" },
  { name: "Colony Specialty", file: "colony.png", match: "Colony" },
  { name: "Covington Specialty", file: "covington.png", match: "Covington" },
  { name: "General Star", file: "general-star.png", match: "General Star" },
  { name: "Great American", file: "great-american.png", match: "Great American" },
  { name: "Lexington Insurance", file: "lexington.png", match: "Lexington" },
  { name: "Mt. Hawley", file: "mt-hawley.png", match: "Mt. Hawley" },
  { name: "Mt. Vernon", file: "mt-vernon.png", match: "Mt. Vernon" },
  { name: "Seneca Insurance", file: "seneca.png", match: "Seneca" },
  { name: "Sigma Underwriting", file: "sigma.png", match: "Sigma" },
  { name: "United National", file: "united-national.png", match: "United National" },
];

export const IMAGES = {
  hero: "/assets/skyline-street.webp",
  towerFlag: "/assets/tower-flag.webp",
  tealBuilding: "/assets/teal-building.webp",
  diana: "/assets/diana.jpg",
  properties2: "/assets/properties-building.jpg",
  aboutTeam: "/assets/about-us.jpg",
  whiteBuilding: "/assets/white-building.jpg",
  industrialPark: "/assets/industrial-park.jpg",
  armando: "/assets/armando.jpg",
  exchange: "/assets/exchange-building.jpg",
  logo: "/assets/logo.jpeg",
  shoppingCenter: "/assets/shopping-center.jpg",
  condo: "/assets/florida-condo-insurance.jpg",
  business: "/assets/business-insurance.jpg",
  hurricaneDamage: "/assets/hurricane-damage.jpg",
  hurricaneTrees: "/assets/hurricane-trees.jpg",
  anniversary30: "/assets/30-years.png",
};
